/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "api85851ce2",
            "endpoint": "https://rx26gmv423.execute-api.ap-northeast-2.amazonaws.com/main",
            "region": "ap-northeast-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ugphxxlonjccnfnwainopujqla.appsync-api.ap-northeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-dhu6unsqffdxxb7hj2ojqdzfwi",
    "aws_cognito_identity_pool_id": "ap-northeast-2:e4b02509-105d-4bbb-833f-e0e5757e380d",
    "aws_cognito_region": "ap-northeast-2",
    "aws_user_pools_id": "ap-northeast-2_RJ9xjsH19",
    "aws_user_pools_web_client_id": "6887spas14o53di70shlqde6oq",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "ghosthomeadmin-storage-c5898b6a8dd89-main",
    "aws_user_files_s3_bucket_region": "ap-northeast-2"
};


export default awsmobile;
